// extracted by mini-css-extract-plugin
export var footer = "HowToAccess-module--footer--B765M";
export var header = "HowToAccess-module--header--LlRcg";
export var wrapper = "HowToAccess-module--wrapper--EuQ6c";